export default defineNuxtRouteMiddleware((to, from) => {
    if (to.path !== '/resume') return;

    const tokenID = to.query.token
    if (!tokenID) navigateTo('/resume-ko');
    if (tokenID?.length !== 36) navigateTo('/resume-ko');

    setStateValue("resumeTokenID", tokenID)
    
})